import { Icon, IconProps } from './Icon';

export type DelProps = IconProps;

export const Del = (props: DelProps) => (
  <Icon width="20px" height="20px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path d="m14.167 7.5-5 5m0-5 5 5m-11.9-1.7 3.6 4.8c.293.391.44.587.626.728.164.125.35.218.55.274.224.065.468.065.957.065h6.333c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 0 0 1.093-1.092c.272-.535.272-1.235.272-2.635V7.333c0-1.4 0-2.1-.272-2.635a2.5 2.5 0 0 0-1.093-1.092c-.535-.273-1.235-.273-2.635-.273H8c-.489 0-.733 0-.958.064-.198.057-.385.15-.55.275-.185.141-.332.337-.625.728l-3.6 4.8c-.215.287-.323.43-.365.588a.834.834 0 0 0 0 .424c.042.158.15.301.365.588Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
